import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Gavel, Printer } from "lucide-react";
import axios from "axios";
import { StatRow } from "./QuarterReview";
import { YearBody } from "./YearReview";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Public, read-only view of a shared annual review. */
export default function YearReviewPublic() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND}/api/shared-year-review/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail?.message || "This link is no longer available."));
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] text-[#fafafa] flex items-center justify-center p-8">
        <p className="text-[#8a8a8a]" data-testid="year-public-error">{error}</p>
      </div>
    );
  }
  if (!data) {
    return <div className="min-h-screen bg-[#0a0a0a] text-[#8a8a8a] flex items-center justify-center p-8">Loading…</div>;
  }

  const { review, chair_name: chairName } = data;
  return (
    <div className="min-h-screen bg-[#0a0a0a] py-12 px-4">
      <style>{`
        @media print {
          @page { size: A4; margin: 18mm 16mm; }
          .no-print { display: none !important; }
          .board-book-page { box-shadow: none !important; }
          .board-book-section { break-inside: avoid; }
          .board-book-cover { break-after: page; }
        }
        .board-book-page { font-family: 'Fraunces','Cormorant Garamond','Georgia',serif; }
      `}</style>
      <div className="no-print max-w-3xl mx-auto mb-6 flex items-center justify-between">
        <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-[#c89f45]">Boardroom · shared annual review</span>
        <button type="button" onClick={() => window.print()}
          className="inline-flex items-center gap-2 border border-[#2a2a2a] hover:border-[#c89f45] text-[#eaeaea] hover:text-[#c89f45] rounded-md px-3 py-1.5 text-xs transition-colors"
          data-testid="year-public-print">
          <Printer size={12} /> Print
        </button>
      </div>
      <article className="board-book-page max-w-3xl mx-auto bg-white text-[#111] rounded-md shadow-2xl p-6 sm:p-10 lg:p-14" data-testid="year-public-page">
        <section className="board-book-cover text-center py-8">
          <div className="inline-flex items-center justify-center h-14 w-14 rounded-sm border border-[#c89f45] mb-6">
            <Gavel size={22} style={{ color: "#8a6c1f" }} />
          </div>
          <p className="text-[10px] font-mono uppercase tracking-[0.3em]" style={{ color: "#8a6c1f" }}>
            Board Book · Annual review
          </p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">{review.headline || `${review.year} in the chair`}</h1>
          <p className="text-sm text-[#555] mt-4 font-mono">The year of {review.year}</p>
          <p className="text-sm text-[#555] mt-1 font-mono">Chair · {chairName}</p>
        </section>
        <StatRow stats={review.stats || {}} />
        <YearBody review={review} />
      </article>
      <p className="no-print text-center text-xs text-[#666] mt-8 font-mono">
        Compiled in Boardroom · <a href="/" className="text-[#c89f45] hover:underline">foundtheroom.com</a>
      </p>
    </div>
  );
}
